import { render, staticRenderFns } from "./returnGoodsList.vue?vue&type=template&id=5f5c9220&scoped=true&"
import script from "./returnGoodsList.vue?vue&type=script&lang=js&"
export * from "./returnGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./returnGoodsList.vue?vue&type=style&index=0&id=5f5c9220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5c9220",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/jenkins/workspace/product_operation/package_operation-saasmobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f5c9220')) {
      api.createRecord('5f5c9220', component.options)
    } else {
      api.reload('5f5c9220', component.options)
    }
    module.hot.accept("./returnGoodsList.vue?vue&type=template&id=5f5c9220&scoped=true&", function () {
      api.rerender('5f5c9220', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/returnGoodsList.vue"
export default component.exports